import { render, staticRenderFns } from "./zdqr.vue?vue&type=template&id=6ff6f432&scoped=true&"
import script from "./zdqr.vue?vue&type=script&lang=js&"
export * from "./zdqr.vue?vue&type=script&lang=js&"
import style0 from "./zdqr.vue?vue&type=style&index=0&id=6ff6f432&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff6f432",
  null
  
)

export default component.exports